import React, { useState, useEffect } from 'react';

import {
  Wrapper,
} from './style';

interface Iamport {
  init: (identificationCode: string) => void;
  request_pay: (params: object, callback: (response: any) => void) => void;
}

interface Props {
  params: object;
  isPaid: boolean,
  onSuccess?: (response: any) => void;
  onFailed?: (response: any) => void;
  onCompleted?: (response: any) => void;
}

const Iamport:React.FC<Props> = ({
  params, isPaid, onSuccess, onFailed, onCompleted
}) => {
  const [, setSDK] = useState(false);

  const loadJQuery = () => {
    ((d, s, id, cb) => {
      const element = d.getElementsByTagName(s)[0];
      const fjs: any = element;
      let js: any = element;

      js = d.createElement(s);
      js.id = id;
      js.src = 'https://code.jquery.com/jquery-3.4.1.min.js';
      fjs.parentNode.insertBefore(js, fjs);
      js.onload = cb;
    })(document, 'script', 'iamport-jquery', () => {
      loadIamportSDK();
    });
  };

  const requestPay = () => {
    const impInstance: Iamport = (window as any).IMP;
    const requestParams = Object.assign({}, params, {
      pg: 'nice',
    });

    impInstance.request_pay(requestParams, (rsp: any) => {
      if (rsp.success) {
        if (onSuccess) {
          onSuccess(rsp);
        }
      } else {
        if (onFailed) {
          onFailed(rsp);
        }
      }

      if (onCompleted) {
        onCompleted(rsp);
      }
    });
  };

  useEffect(() => {
    if (document.getElementById('iamport-jssdk')) {
      setSDK(true);
    }
    loadJQuery();
    let iamportRoot = document.getElementById('iamport');
    if (!iamportRoot) {
      iamportRoot = document.createElement('div');
      iamportRoot.id = 'iamport';
      document.body.appendChild(iamportRoot);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isPaid) {
      requestPay();
    }
    // eslint-disable-next-line
  }, [isPaid]);

  const loadIamportSDK = () => {
    ((d, s, id, cb) => {
      const element = d.getElementsByTagName(s)[0];
      const fjs: any = element;
      let js: any = element;

      js = d.createElement(s);
      js.id = id;
      js.src = 'https://cdn.iamport.kr/js/iamport.payment-1.1.7.js';
      fjs.parentNode.insertBefore(js, fjs);
      js.onload = cb;
    })(document, 'script', 'iamport-jssdk', () => {
      const impInstance: Iamport = (window as any).IMP;
      impInstance.init('imp91841193');
    });
  }

  return (
    <Wrapper></Wrapper>
  );
};

export default Iamport;
